'use strict';

const AuditCharts = function () {
  
  let pageCharts = {};

  const chartColors = {
    blue: "rgb(54, 162, 235)",
    green: "rgb(75, 192, 192)",
    grey: "rgb(201, 203, 207)",
    orange: "rgb(255, 159, 64)",
    purple: "rgb(153, 102, 255)",
    red: "rgb(255, 99, 132)",
    yellow: "rgb(255, 205, 86)",
    transparent: "rgba(255, 255, 255, 0)"
  };

  function createBarChart(elem, stats) {
    let data = [];
    let labels = [];
    let $chart = document.getElementById(elem);

    if (stats && stats.length) {
      stats.forEach(stat => {
        if (stat.max[0] > 0) {
          labels.push(stat.category);
          data.push(stat.values[0] / stat.max[0] * 100);
        }
      });
    }

    if (elem in pageCharts && pageCharts[elem])
      pageCharts[elem].destroy();
    pageCharts[elem] = new Chart($chart, {
      type: 'bar',
      options: {
        scales: {
          yAxes: [{
            gridLines: {
              color: chartColors.grey,
              zeroLineColor: chartColors.grey
            },
            ticks: {
              callback: function(value) {
                return value;
              },
              min: 0,
              max: 100
            }
          }],
          xAxes: [{
            bounds: 'ticks',
          }]
        },
        tooltips: {
          callbacks: {
            title: function(item) {
              return item[0].xLabel;
            },
            label: function(item, data) {
             return item.yLabel;
            }
          }
        }
      },
      data: {
        labels: labels,
        datasets: [{
          label: '',
          data: data,
          backgroundColor: chartColors.blue,
          borderColor: chartColors.green,
          borderWidth: 1,
        }]
      }
    });
  }
  function createRadarChart(elem, stats) {
    let data = [];
    let labels = [];
    let $chart = document.getElementById(elem);

    if (stats && stats.length) {
      stats.forEach(stat => {
        if (stat.max[0] > 0) {
          labels.push(stat.category);
          data.push(stat.values[0] / stat.max[0] * 100);
        }
      });
    }

    if (elem in pageCharts && pageCharts[elem]) {
      pageCharts[elem].destroy();
    }
    pageCharts[elem] = new Chart($chart, {
      type: 'radar',
      options: {
        scale: {
          ticks: {
            min: 0,
            max: 100,
          },
        },
        tooltips: {
          callbacks: {
            label: function(item, data) {
             return item.yLabel;
            }
          }
        }
      },
      data: {
        labels: labels,
        datasets: [{
          label: '',
          data: data,
          borderColor: chartColors.green,
          borderWidth: 3,
          fill: false
        }]
      }
    });
  }

  return {
    createBarChart: createBarChart,
    createRadarChart: createRadarChart,
  };
};



// WEBPACK FOOTER //
// src/assets/js/auditCharts.js